import React from 'react';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';

function LoadingLayer(props) {

    const { isActive, message } = props;

    return (
        <LoadingOverlay
            active={isActive || false}
            spinner={<BeatLoader />}
            className={"loadingLayer"}
            text={message == null ? i18next.t('common:loading') : message}
        >
            {props.children}
        </LoadingOverlay>
    );
}

export default withNamespaces(['common'], { wait: true })(LoadingLayer);